export default __webpack_public_path__ + "static/media/gallery_00.0e4bede8.jpg";